<template>
  <div class="ecm-navbar__top">
    <div class="ecm-navbar__top-logo">
      <h1 class="logo--title" @click="handleToHome">BukuBook</h1>
    </div>
    <div class="ecm-navbar__top-content">
      <div class="ecm-navbar__content-links">
        <div class="ecm-navbar__content-link link--search">
          <el-autocomplete
            class="inline-input"
            v-model="search"
            :fetch-suggestions="querySearch"
            placeholder="Find your book"
            :trigger-on-focus="false"
            @select="handleSelect"
            spellcheck="false"
          ></el-autocomplete>
          <div class="ecm-navbar__content-link-icon icon--search">
            <i @click="handleSearch" class="fas fa-search"></i>
          </div>
        </div>
        <div v-if="isOpenAccount" class="ecm-navbar__content-link link--open">
          <el-badge :value="totalWishlist" :max="999" :hidden="totalWishlist == 0">
            <button @click=" () => {
                  $router.push('/wishlist')
                    .catch(() => {})
              }" size="small">
              <i class="fas fa-heart"></i>
            </button>
          </el-badge>
          <el-badge :value="totalCart" :hidden="totalCart == 0" :max="999">
            <button @click=" () => {
                  $router.push('/cart')
                    .catch(() => {})
              }" size="small">
              <i class="fas fa-shopping-cart"></i>
            </button>
          </el-badge>
          <el-popover
            class="ecm-navbar__content-link-icon icon--account"
            placement="bottom-end"
            v-model="isAccountOptionActive">
            <div class="ecm-navbar__content-link-item">
              <div
                v-for="(link) in optionsAccount" :key="link.key"
                class="ecm-navbar__content-link-item-point"
                @click="handleAccountOption(link)"
              >
                <div class="ecm-navbar__content-link-item-point--icon">
                  <i :class="link.logo"></i>
                </div>
                <p class="ecm-navbar__content-link-item-point--desc">{{ link.value }}</p>
              </div>
            </div>
            <img v-if="userImage" slot="reference" :src="userImage" alt="profile picture">
            <img v-else slot="reference" src="@/assets/images/batman.jpeg" alt="profile picture">
          </el-popover>
        </div>
        <div v-if="!isOpenAccount" class="ecm-navbar__content-link link--close">
          <button @click="$router.push('/login')" class="ecm-navbar__content-link-btn btn--sign">SIGN IN</button>
          <button @click="$router.push('/register')" class="ecm-navbar__content-link-btn btn--register">SIGN UP</button>
        </div>
        <i @click="handleOpenSlideNav" class="fas fa-bars"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TopNavbar',
  data () {
    return {
      search: '',
      isAccountOptionActive: false,
      optionsAccount: [
        {
          key: 'setting',
          value: 'Account',
          logo: 'fas fa-user-circle'
        },
        {
          key: 'transactions',
          value: 'Transactions',
          logo: 'fas fa-handshake'
        },
        {
          key: 'signout',
          value: 'Sign out',
          logo: 'fas fa-power-off'
        }
      ],
      findBook: null,
      isOpenAccount: localStorage.getItem('access_token')
    }
  },
  mounted () {
    if (this.isOpenAccount) {
      this.getWishlistCount()
      this.getCartCount()
    }
    if (this.$data.isOpenAccount) {
      this.handleFetchUser()
    }
  },
  computed: {
    ...mapState({
      totalWishlist: state => state.wishlist.total,
      totalCart: state => state.cart.total,
      userImage: state => state.user.user.image
    })
  },
  methods: {
    ...mapActions({
      getWishlistCount: 'wishlist/fetchCount',
      getCartCount: 'cart/fetchCount',
      fetchBooksName: 'book/fetchBooksName',
      fetchUser: 'user/fetchUser'
    }),
    async handleFetchUser () {
      try {
        await this.fetchUser({
          userId: localStorage.getItem('userId')
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleAccountOption (link) {
      this.$data.isAccountOptionActive = !this.$data.isAccountOptionActive
      if (link.key === 'signout') {
        localStorage.removeItem('access_token')
        localStorage.removeItem('userId')
        this.$data.isOpenAccount = false
        this.$root.$emit('fetchBooks')
        this.$root.$emit('fetchBestSeller')
        this.$root.$emit('fetchBook', 'signout')
        if (['Cart', 'Checkout', 'Wishlist', 'Transactions', 'Detail Transaction', 'Setting'].includes(this.$route.name)) {
          this.$router.push('/')
        }
      } else {
        this.$router.push(`/${link.key}`)
      }
    },
    handleToHome () {
      this.$router.push('/')
        .catch(() => {})
    },
    handleOpenSlideNav () {
      this.$data.isOpenSlideNav = !this.$data.isOpenSlideNav
      const background = document.querySelector('.ecm__navbar-background')
      const slideNav = document.querySelector('.ecm__navbar-slide')
      if (this.$data.isOpenSlideNav) {
        slideNav.style.display = 'block'
        slideNav.style.transform = 'translateX(0)'
        background.style.display = 'block'
      } else {
        slideNav.style.transform = 'translateX(105%)'
        background.style.display = 'none'
      }
    },
    querySearch (queryString, cb) {
      if (queryString) {
        this.fetchBooksName({
          title: queryString,
          cbSuccess: (resp) => {
            cb(resp)
          },
          cbError: (err) => {
            console.log(err)
          }
        })
      }
    },
    handleSelect (book) {
      this.$data.findBook = book
    },
    handleSearch () {
      this.$data.isSearch = !this.$data.isSearch
      if (!this.$data.isSearch && this.$data.search) {
        if (this.$data.findBook) {
          if (this.$data.findBook.value === this.$data.search) {
            this.$router.push(`${this.$data.findBook.id}/${this.$data.findBook.value}`)
          } else {
            this.$router.push(`books?title=${this.$data.search}`)
          }
        } else {
          this.$router.push(`books?title=${this.$data.search}`)
        }
      }
      const searchEl = document.querySelector('.ecm-navbar__content-link.link--search')
      searchEl.style.width = this.$data.isSearch ? '220px' : '32px'
      searchEl.style.borderRadius = this.$data.isSearch ? '22px' : '22px'
      this.$data.search = ''
      this.$data.findBook = null
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm-navbar__top {
  padding: 0 2rem;
  display: flex;
  align-items: center;
  flex: 1;
  height: 75px;
  border-bottom: 1.5px solid rgba(0, 0, 0, 0.111);
  background: var(--color-blue-background);
  .ecm-navbar__top-logo {
    h1 {
      font-size: 30px;
      cursor: pointer;
      color: white;
      width: auto;
    }
  }
  .ecm-navbar__top-content {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    .ecm-navbar__content-links {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ecm-navbar__content-link {
        margin-left: 13px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 17px;
        color: rgba(0, 0, 0, 0.679);
        transition: width .3s;
        position: relative;
        height: 32px;
        &.link--search {
          background: white;
          overflow: hidden;
          width: 32px;
          border-radius: 22px;
          justify-content: flex-end;
          transition: .3s;
          &::v-deep .el-autocomplete {
            .el-input {
              input {
                z-index: 10;
                margin-right: 35px;
                width: 175px;
                border: none;
                outline: none;
                font-size: 14px;
                color: rgb(56, 56, 56);
                font-weight: 400;
                padding: 0;
                &::placeholder {
                  color: rgb(12, 42, 107);
                }
              }
            }
          }
        }
        .el-badge {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 32px;
          width: 32px;
          background: white;
          border-radius: 50%;
          button {
            display: flex;
            justify-content: center;
            align-items: center;
            background: none;
            border: none;
            cursor: pointer;
            height: 85%;
            width: 85%;
            i {
                font-size: 15px;
              &.fa-heart {
                color: red;
              }
              &.fa-shopping-cart {
                color: var(--color-blue-background);
              }
            }
          }
          &::v-deep {
            .el-badge__content {
              font-size: 10px;
            }
            .el-badge__content.is-fixed {
              top: -5px;
              right: 15px;
              background: rgb(255, 24, 24);
            }
          }
        }
        .ecm-navbar__content-link-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 32px;
          width: 32px;
          position: relative;
          border-radius: 50%;
          cursor: pointer;
          &.icon--search {
            box-shadow: none;
            border-radius: none;
            cursor: default;
            z-index: 11;
            position: absolute;
            transition: .3s;
            &:hover {
              color: var(--color-blue);
            }
          }
          .fa-search {
            cursor: pointer;
            font-size: 15px;
          }
          &.icon--account {
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            &::v-deep {
              .el-popover__reference-wrapper {
                height: 100%;
                widows: 100%;
              }
            } 
            img {
              width: 100%;
              height: 100%;
            }
            border: none;
            border-radius: none;
          }
        }
        &.link--open {
          width: 120px;
          justify-content: space-between;
        }
        &.link--close {
          width: 165px;
          justify-content: space-between;
        }
        .ecm-navbar__content-link-btn {
          width: 80px;
          height: 100%;
          border: none;
          outline: none;
          font-weight: 500;
          border-radius: 3px;
          cursor: pointer;
          border: 2px solid var(--color-blue-background);
          &.btn--sign {
            background: var(--color-blue-background);
            color: white;
          }
          &.btn--register {
            background: white;
            color: var(--color-blue-background);
          }
        }
      }
      .fa-bars {
        display: none;
        cursor: pointer;
        margin-left: 10px;
      }
    }
  }
}
</style>
